import { Button, Dropdown, Menu, Modal, notification } from "antd";
import React, { useState } from "react";
import { FaEllipsisV, FaPaperPlane } from "react-icons/fa";
import { axios, getToken, URL_API } from "../utils";
import { resCatch } from "../views/util/helper";

// OracleInterfaceFlag / InterfaceFlag: 0, NULL = รอส่ง · -1 = BC ตอบ error · 99 = กำลังส่ง · 1 = ส่งแล้ว (G#1551)
export const canSendBc = (flag) =>
  flag === null || flag === undefined || +flag === 0 || +flag === -1;

// ปุ่ม "ส่ง BC" รายใบ (จุดสามจุด → dropdown): ส่งใบที่ยังไม่ได้ส่งก่อนรอบ schedule ของ Service (ทุก 10 นาที) หรือส่งซ้ำใบที่ BC ตอบ error
const SendBcButton = ({ url, flag, onDone = () => {}, className = "" }) => {
  const [loading, setLoading] = useState(false);

  if (!canSendBc(flag)) return null;

  const is_error = +flag === -1;

  const handleSend = () => {
    setLoading(true);
    axios({
      method: "post",
      baseURL: URL_API,
      url,
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then(({ data }) => {
        const notify =
          data?.data?.status === "success"
            ? notification.success
            : notification.info;
        notify({ message: "ส่ง BC", description: data?.message });
      })
      .catch((e) => resCatch(e))
      .finally(() => {
        setLoading(false);
        onDone();
      });
  };

  const handleMenuClick = () =>
    Modal.confirm({
      title: is_error
        ? "ใบนี้ส่ง BC ไม่ผ่าน ยืนยันการส่งซ้ำ?"
        : "ยืนยันการส่งเข้า BC?",
      okText: "ส่ง",
      cancelText: "ยกเลิก",
      onOk: handleSend,
    });

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="send-bc">
        <FaPaperPlane className="mr-2" />
        {is_error ? "ส่ง BC ซ้ำ" : "ส่ง BC"}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      placement="bottomRight"
      disabled={loading}
    >
      <Button
        size="small"
        shape="circle-outline"
        type="primary"
        loading={loading}
        className={className}
      >
        {!loading && <FaEllipsisV style={{ fontSize: 10 }} />}
      </Button>
    </Dropdown>
  );
};

export default SendBcButton;
